<template>
  <div class="promoter-list" ref="container">
    <div class="header">
      <div class="promoterHeader bg-color-red">
        <div class="headerCon acea-row row-between-wrapper">
          <div>
            <div class="name">团队人数</div>
            <div>
              <span class="num">{{first}}</span
              >人
            </div>
          </div>
          <div>
            <div class="name">推广人数</div>
            <div>
              <span class="num">{{totalSpread}}</span
              >人
            </div>  
          </div>
          <div class="iconfont icon-tuandui"></div>
        </div>
      </div>
      <div class="nav acea-row row-around">
        <!-- <div
          class="item"
          :class="screen.grade == 0 ? 'on' : ''"
          @click="checkGrade(0)"
        >
          分销({{ first }})
        </div>
        <div
          class="item"
          :class="screen.grade == 1 ? 'on' : ''"
          @click="checkGrade(1)"
        > -->
        <div
          class="item"
          :class="screen.agent == 0 ? 'on' : ''"
          @click="checkGrade(0)"
        >
          分销({{ totalMine }})
        </div>
        <div
          class="item"
          :class="screen.agent == 1 ? 'on' : ''"
          @click="checkGrade(1)"
        >
          代理({{ second }})
        </div>
      </div>
      <div class="search acea-row row-between-wrapper">
        <form @submit.prevent="submitForm">
          <div class="input">
            <input placeholder="点击搜索会员名称" v-model="screen.keyword" />
            <span class="iconfont icon-guanbi" @click="screen.keyword = ''"></span>
          </div>
        </form>
        <div class="iconfont icon-sousuo2" @click="submitForm"></div>
      </div>
    </div>
    <div class="list">
      <div
        class="sortNav acea-row row-middle"
        :class="fixedState === true ? 'on' : ''"
      >
        <div class="sortItem" @click="sort('childCount')">
          团队排序
          <img src="@assets/images/sort1.png" v-if="childCount == 1" />
          <img src="@assets/images/sort2.png" v-if="childCount == 2" />
          <img src="@assets/images/sort3.png" v-if="childCount == 3" />
        </div>
        <div class="sortItem" @click="sort('numberCount')">
          金额排序
          <img src="@assets/images/sort1.png" v-if="numberCount == 1" />
          <img src="@assets/images/sort2.png" v-if="numberCount == 2" />
          <img src="@assets/images/sort3.png" v-if="numberCount == 3" />
        </div>
        <div class="sortItem" @click="sort('orderCount')">
          订单排序
          <img src="@assets/images/sort1.png" v-if="orderCount == 1" />
          <img src="@assets/images/sort2.png" v-if="orderCount == 2" />
          <img src="@assets/images/sort3.png" v-if="orderCount == 3" />
        </div>
      </div>
      <div :class="fixedState === true ? 'sortList' : ''">
        <div
          class="item acea-row row-between-wrapper"
          v-for="(val, index) in spreadList"
          :key="index"
        >
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue"><img :src="val.avatar" /></div>
            <div class="text">
              <div class="name line1">{{ val.nickname }}</div>
              <div class="identity" v-if="val.is_promoter == 1 && val.promoter_type == 0">
                推广产品:
                <sapn style="color: #217714;" >
                  牛津绿
                </sapn>
              </div>
              <div class="identity" v-if="val.is_promoter == 1 && val.promoter_type == 1">
                推广产品:
                <sapn style="color: #80cdd4;">
                  不焦虑版
                </sapn>
              </div>
              <div>加入时间: {{ val.time }}</div>
              <button class="distribution-button" v-if="userinfo.agent_city_type != '' && userinfo.agent_range == 'province' && val.promoter_type != 1"   @click="becomeDistribution(val.uid,val.nickname)" >设为不焦绿推广员</button>
              <!-- <button class="distribution-button"  @click="becomeDistribution(val.uid,val.nickname)" >设为不焦虑版推广员</button> -->
            </div>
          </div>
          <div class="right">
            <div>
              <span class="font-color-red">{{ val.childCount || 0 }}</span> 人
            </div>
          </div>
          <div class="bottom acea-row row-between-wrapper">
            <div class="bottom-item">
              <div>个人：<span class='font-color-red'>{{val.ordersum ? val.ordersum : 0}}单 | {{val.number ? val.number : 0}} 元</span></div>
            </div>
            <div class="bottom-item text-right">
              <div>下级：<span class='font-color-red'>{{val.orderCount ? val.orderCount : 0}}单 | {{val.numberCount ? val.numberCount : 0}} 元</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { Dialog } from 'vant';
import { getUserInfo,getSpreadUser,becomeDistributor } from "../../../api/user";
import Loading from "@components/Loading";
export default {
  name: "PromoterList",
  components: {
    Loading,
  },
  props: {},
  data: function() {
    return {
      userinfo: {}, //当前用户信息,

      fixedState: false,
      screen: {
        page: 1,
        limit: 15,
        grade: 0,
        keyword: "",
        sort: "",
        agent: 0
      },
      childCount: 2,
      numberCount: 2,
      orderCount: 2,
      loaded: false,
      loading: false,
      spreadList: [],
      loadTitle: "",
      first: "",
      second: "",
      totalSpread:'', //推广人数
      totalMine:'',

    };
  },
  mounted: function() {
    getUserInfo().then(res=>{
      this.userinfo = res.data
    })
    this.getSpreadUsers();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getSpreadUsers();
    });
  },
  watch: {
    "screen.sort": function() {
      this.screen.page = 0;
      this.loaded = false;
      this.loading = false;
      this.spreadList = [];
      this.getSpreadUsers();
    }
  },
  methods: {
    handleScroll: function() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.querySelector(".header").clientHeight;
      if (scrollTop >= offsetTop) {
        this.fixedState = true;
      } else {
        this.fixedState = false;
      }
    },
    submitForm: function() {
      this.screen.page = 0;
      this.loaded = false;
      this.loading = false;
      this.spreadList = [];
      this.getSpreadUsers();
    },
    getSpreadUsers: function() {
      let that = this,
        screen = that.screen;
      if (that.loaded || that.loading) return;
      that.loading = true;
      getSpreadUser(screen).then(
        res => {
          that.loading = false;
          that.spreadList.push.apply(that.spreadList, res.data.list);
          that.loaded = res.data.list.length < that.screen.limit; //判断所有数据是否加载完成；
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.screen.page = that.screen.page + 1;
          that.first = res.data.total;
          that.second = res.data.totalLevel;
          that.totalSpread = res.data.totalSpread;
          that.totalMine = res.data.totalMine;
        },
        error => {
          that.$dialog.message(error.msg);
        },
        300
      );
    },
    checkGrade: function(val) {
      if(val == this.screen.agent)return;
      // if (val == this.screen.grade) return;
      else {
        this.screen.page = 1;
        // this.screen.grade = val;
        this.screen.agent = val;
        this.loading = false;
        this.loaded = false;
        this.spreadList = [];
        this.getSpreadUsers();
      }
    },
    sort: function(types) {
      let that = this;
      switch (types) {
        case "childCount":
          if (that.childCount == 2) {
            that.childCount = 1;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.sort = "childCount DESC";
          } else if (that.childCount == 1) {
            that.childCount = 3;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.sort = "childCount ASC";
          } else if (that.childCount == 3) {
            that.childCount = 2;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.sort = "";
          }
          break;
        case "numberCount":
          if (that.numberCount == 2) {
            that.numberCount = 1;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.sort = "numberCount DESC";
          } else if (that.numberCount == 1) {
            that.numberCount = 3;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.sort = "numberCount ASC";
          } else if (that.numberCount == 3) {
            that.numberCount = 2;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.sort = "";
          }
          break;
        case "orderCount":
          if (that.orderCount == 2) {
            that.orderCount = 1;
            that.numberCount = 2;
            that.childCount = 2;
            that.screen.sort = "orderCount DESC";
          } else if (that.orderCount == 1) {
            that.orderCount = 3;
            that.numberCount = 2;
            that.childCount = 2;
            that.screen.sort = "orderCount ASC";
          } else if (that.orderCount == 3) {
            that.orderCount = 2;
            that.numberCount = 2;
            that.childCount = 2;
            that.screen.sort = "";
          }
          break;
        default:
          that.screen.sort = "";
      }
    },


    // 成为分销员
    becomeDistribution(uid,name){
    
      Dialog.confirm({
          title: '提示',
          message:`您将同意 ${name} 成为不焦虑版推广员`,
        })
          .then(() => {
            becomeDistributor({
              promoter_uid:uid
            }).then(res=>{
              this.$dialog.alert({ message: "添加成功" });
              this.$nextTick();
            })
            .catch(err=>{
              this.$dialog.alert({  
                title: '提示',
                message:err.msg
              });
            })
          })
          .catch((err) => {
      });
    }
  }
};
</script>
